(() => {
  const titleSelector = '.nh-cat__buybox > h1, .nh-pdp__buybox > h1, .nh-lite__buybox > h1';
  const observedBuyboxes = new WeakSet();
  let frame = 0;

  const titleFitsTwoLines = (title) => {
    const styles = window.getComputedStyle(title);
    const lineHeight = Number.parseFloat(styles.lineHeight);

    return title.scrollWidth <= title.clientWidth + 1
      && title.scrollHeight <= (lineHeight * 2) + 2;
  };

  const fitTitle = (title) => {
    if (!(title instanceof HTMLElement) || title.clientWidth < 1) return;

    const isMobile = window.matchMedia('(max-width: 640px)').matches;
    const minSize = isMobile ? 18 : 24;
    const maxSize = isMobile
      ? Math.min(38, Math.max(32, title.clientWidth * .105))
      : Math.min(52, Math.max(40, title.clientWidth * .085));

    let low = minSize;
    let high = maxSize;
    let best = minSize;

    title.style.setProperty('--nh-product-title-fit-size', `${maxSize}px`);

    if (titleFitsTwoLines(title)) {
      best = maxSize;
    } else {
      for (let index = 0; index < 8; index += 1) {
        const candidate = (low + high) / 2;
        title.style.setProperty('--nh-product-title-fit-size', `${candidate}px`);

        if (titleFitsTwoLines(title)) {
          best = candidate;
          low = candidate;
        } else {
          high = candidate;
        }
      }
    }

    title.style.setProperty('--nh-product-title-fit-size', `${best.toFixed(2)}px`);
    title.dataset.nhTitleFitted = 'true';
  };

  const fitAllTitles = (root = document) => {
    root.querySelectorAll(titleSelector).forEach(fitTitle);
  };

  const scheduleFit = () => {
    window.cancelAnimationFrame(frame);
    frame = window.requestAnimationFrame(() => fitAllTitles());
  };

  const resizeObserver = 'ResizeObserver' in window
    ? new ResizeObserver((entries) => {
      entries.forEach(({ target }) => {
        const title = target.querySelector(':scope > h1');
        if (title) fitTitle(title);
      });
    })
    : null;

  document.querySelectorAll(titleSelector).forEach((title) => {
    const buybox = title.parentElement;
    if (!resizeObserver || !buybox || observedBuyboxes.has(buybox)) return;
    resizeObserver.observe(buybox);
    observedBuyboxes.add(buybox);
  });

  scheduleFit();
  window.addEventListener('resize', scheduleFit, { passive: true });
  document.addEventListener('shopify:section:load', scheduleFit);

  if (document.fonts?.ready) {
    document.fonts.ready.then(scheduleFit);
  }
})();
